import React from 'react';
import { Button } from 'reactstrap';
import i18next from 'i18next';
import {
  ICompanyContact,
  IRestaurantCompanyWithRestaurantsAndContacts,
  OriginalRestaurant,
} from 'types';
import {
  SimpleTableWithSorting,
  generateColumn,
  getRTOriginal,
  TableCellProps,
} from 'app/components/common';
import { ModalTypes } from 'config';
import withSetModal, { TSetModalFunction } from 'app/containers/WithSetModal';

const ShowAddCompanyContactModalBtn = withSetModal(AddCompanyContactModalBtn);

const buildColumns = () => [
  generateColumn('id'),
  generateColumn('name', { customHeader: i18next.t('companies.company-name') }),
  generateColumn('nip'),
  generateColumn('address', { customHeader: i18next.t('companies.address') }),
  generateColumn('ip', {
    customHeader: i18next.t('companies.assigned-restaurants'),
    customCellFormatter: (
      props: TableCellProps<IRestaurantCompanyWithRestaurantsAndContacts>
    ) => {
      const restaurantCompany =
        getRTOriginal<IRestaurantCompanyWithRestaurantsAndContacts>(props);
      return (
        <div>
          {restaurantCompany.restaurants.length > 0 ? (
            restaurantCompany.restaurants
              .map((r) => `${r.name} (${r.id})`)
              .join(', ')
          ) : (
            <span className="text-danger">
              {i18next.t('companies.no-assigned-restaurants')}
            </span>
          )}
        </div>
      );
    },
  }),
  generateColumn('fake-property-2', {
    customHeader: i18next.t('companies.contact-persons'),
    customCellFormatter: (
      props: TableCellProps<IRestaurantCompanyWithRestaurantsAndContacts>
    ) => {
      const restaurantCompany =
        getRTOriginal<IRestaurantCompanyWithRestaurantsAndContacts>(props);
      return (
        <div>
          {restaurantCompany.contacts.length > 0 ? (
            restaurantCompany.contacts.map((c) => (
              <div className="mb-2 bb-1" key={c.phone}>
                {c.first_name} {c.last_name} ({c.position}), {c.phone},{' '}
                {c.email}
              </div>
            ))
          ) : (
            <span className="text-danger">{i18next.t('companies.no-contacts')}</span>
          )}
          <div>
            {/* @ts-ignore */}
            <ShowAddCompanyContactModalBtn company={restaurantCompany} />
          </div>
        </div>
      );
    },
  }),
];

const columns = buildColumns();

export interface CompaniesListProps {
  companies: IRestaurantCompanyWithRestaurantsAndContacts[];
}

export const CompaniesList: React.FC<CompaniesListProps> = ({ companies }) => {
  return (
    <SimpleTableWithSorting
      columns={columns}
      data={companies as unknown as OriginalRestaurant[]}
      hasFilters
      pageSize={100}
    />
  );
};

interface IAddCompanyContactModalBtnProps {
  company: IRestaurantCompanyWithRestaurantsAndContacts;
  setModal: TSetModalFunction;
}

function AddCompanyContactModalBtn(props: IAddCompanyContactModalBtnProps) {
  const { company, setModal } = props;
  return (
    <Button
      type="button"
      onClick={() =>
        setModal(
          {
            title: i18next.t('companies.add-contact-modal-title', { name: company.name }),
            confirm: (newContact: ICompanyContact) => {
              console.debug('created contact', newContact);
            },
            modalSpecificProps: {
              companyId: company.id,
            },
            confirmColor: 'success',
          },
          ModalTypes.ADD_COMPANY_CONTACT
        )
      }
    >
      {i18next.t('companies.add-contact')}
    </Button>
  );
}

export default CompaniesList;
